import { Controller, type ControllerProps, type FieldValues } from 'react-hook-form'
import type { JSX } from 'react'
import {
  PasswordInput,
  type PasswordInputProps as SuiPasswordInputProps,
} from 'settle-ui/components/PasswordInput/PasswordInput'

type PasswordInputProps = Omit<SuiPasswordInputProps, 'inputRef'>
type Controller<T extends FieldValues> = Pick<
  ControllerProps<T>,
  'defaultValue' | 'shouldUnregister' | 'name' | 'rules' | 'control'
>
export type PasswordInputPropsControllerProps<T extends FieldValues> = PasswordInputProps & Controller<T>
export type PasswordInputPropsController = <T extends FieldValues>(
  props: PasswordInputPropsControllerProps<T>,
) => JSX.Element

export const PasswordInputController: PasswordInputPropsController = ({
  name,
  rules,
  control,
  defaultValue,
  size = 'medium',
  shouldUnregister,
  required = true,
  margin = 'normal',
  color = 'secondary',
  showPasswordRequirements,
  ...restPasswordInputProps
}) => (
  <Controller
    defaultValue={defaultValue}
    shouldUnregister={shouldUnregister}
    name={name}
    rules={rules}
    control={control}
    render={({ field: { ref, ...fieldProps }, fieldState: { error } }) => {
      const helperText = error ? error.message : restPasswordInputProps.helperText

      return (
        <PasswordInput
          {...fieldProps}
          {...restPasswordInputProps}
          size={size}
          color={color}
          inputRef={ref}
          margin={margin}
          required={required}
          helperText={helperText}
          error={Boolean(error) || restPasswordInputProps.error}
          showPasswordRequirements={showPasswordRequirements}
        />
      )
    }}
  />
)
